import { useIsFetching, useQueryClient } from "@tanstack/react-query"
import { LoaderCircleIcon } from "lucide-react"
import { useStore } from "zustand"

import { store } from "@/lib/store"
import BoundlessLogo from "@/svg/boundless/logo.svg?react"

function PendingQueryInfo() {
  const isFetching = useIsFetching()
  const queryClient = useQueryClient()
  const queries = queryClient.getQueryCache().getAll()

  return (
    <div>
      <p>Active queries: {isFetching}</p>
      <ul className="listDisc">
        {queries
          .filter((q) => q.state.fetchStatus === "fetching")
          .map((q) => (
            <li key={q.queryHash}>{q.queryKey.join(" → ")}</li>
          ))}
      </ul>
    </div>
  )
}

export function PendingComponent({ hideLogo = false }: { hideLogo?: boolean }) {
  const partnerLogo = useStore(store, (state) => state.partnerLogo)

  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-6">
      {!hideLogo &&
        (partnerLogo ? (
          <img src={partnerLogo} alt="Partner Logo" className="h-16 w-auto" />
        ) : (
          <BoundlessLogo className="h-12 w-auto" />
        ))}

      <div className="flex flex-col items-center gap-1">
        <LoaderCircleIcon
          className="text-primary h-24 w-24 animate-spin"
          strokeWidth={1}
        />

        <h1 className="text-muted text-center">Loading...</h1>

        {import.meta.env.DEV && <PendingQueryInfo />}
      </div>
    </div>
  )
}
